// Deprecated: Shopify handles catalog & converted pricing dynamically.
(function () {
  'use strict';
})();